{
  "en": {
    "startPage": {
      "collections": {
        "timedLabel": "Register now",
        "timedTitle": "Free Advent calendar with 24 inspirations"
      },
      "ctaBanner": {
        "aiDSGVOCompliant": {
          "checklist": {
            "1": "Student access to AI Chat, Character Chat, PDF Chat, Image Generator, Text Editor and AI Multimedia Tool",
            "2": "No student registration required",
            "3": "Data is automatically deleted after 24 hours<br><a href=\"{href}\" target=\"_blank\">Learn more</a>"
          },
          "text": "With the fobizz Shared Spaces, your students will get their own access to the <b>fobizz AI tools</b> and can work with them in a <b>data-secure way.</b>",
          "title": "Shared Spaces: Use AI tools with students while protecting their privacy"
        },
        "simpleAndSecure": {
          "checklist": {
            "1": "Simple & secure",
            "2": "GDPR compliant",
            "3": "Innovative: the latest tools to make lessons even better and more varied"
          },
          "subline": "Fobizz AI tools for efficient lesson planning",
          "sublinePrefix": "Includes AI",
          "text": "All the tools you need to plan and deliver lessons in one place.",
          "title": "Design digital lessons easily and securely"
        },
        "startFree": "Start now for free"
      },
      "headers": {
        "assistants": "AI Assistants for You",
        "assistantsBadge": "150+ Chatbots",
        "continueWorkshops": "Continue active courses",
        "pinnedTools": "Pinned Tools",
        "miniTools": "Popular Prompts",
        "miniToolsBadge": "55+ Prompts",
        "myAssistants": "Your assistants",
        "newAssistants": "New assistants",
        "recommendationsForYou": "Recommendations for you",
        "recommendedWorkshops": "Recommendations for you",
        "savedCourses": "Bookmarked courses",
        "savedMaterial": "Bookmarked material",
        "sectionChatTools": "AI Chat and Assistants",
        "sectionFeedbackTools": "AI Feedback and Grading",
        "sectionMaterialTools": "Create materials",
        "sectionMaterials": "Use teaching materials",
        "sectionMultimediaTools": "AI for Media Creation",
        "sectionOnboarding": "Get Started with fobizz",
        "sectionShareTools": "Share content securely",
        "sectionWorkshops": "Discover courses",
        "videoOnboarding": "Get to know fobizz in 100 seconds",
        "yourWorkshops": "Current Live Webinars and Workshops"
      },
      "hiddenFeedbackTools": {
        "badge": "Where are the tools?",
        "tooltip": "These tools are hidden by default and can be enabled at school level if required."
      },
      "howTo": {
        "bookmarkTeaserHeadline": "Bookmark your favorite materials and courses",
        "bookmarkTeaserLinkCourses": "Show bookmarked courses",
        "bookmarkTeaserLinkMaterial": "Show bookmarked materials",
        "bookmarkTeaserText": "Save relevant courses and materials for later by clicking on the heart and add them to your bookmarks.",
        "materialTeaserHeadline": "Sharing is caring: Share materials with others",
        "materialTeaserLink": "Watch tutorial",
        "materialTeaserText": "Share your materials with colleagues and students. You can also use the materials created by others.",
        "materialTeaserTextCommunity": "All material is under the CC-BY license. You can copy and adapt it for free via Remix. Please critically check content and links beforehand, especially regarding copyright and data protection.",
        "materialTeaserVideoId": "1088438338",
        "materialTeaserVideoTitle": "Create and share materials"
      },
      "links": {
        "assistantsCatalog": "Explore Additional Assistants",
        "createClass": "Create Shared Space",
        "hideOnboarding": "Hide fobizz introduction",
        "miniToolsCatalog": "Explore Additional Prompts",
        "toAssistantsCatalog": "Show all",
        "toMaterials": "Show all",
        "toMyAssistantsCatalog": "Show all",
        "toSavedMaterials": "Show bookmarks",
        "toSavedWorkshops": "Show bookmarks",
        "toTools": "Show all",
        "toWorkshops": "Show all",
        "watchTutorial": "Watch tutorial"
      },
      "onboarding": {
        "videoId": "1055247116",
        "videoTitle": "Get to know fobizz in 100 seconds"
      },
      "paragraphs": {
        "mySchoolClassesDisabled": "This feature is disabled for your license group. Please contact the person managing the license for further information.",
        "onboarding": "Discover your possibilities with a short tutorial, a micro-lesson, or dive right into your first course.",
        "recommendationsAndProfile": "These settings will also be applied to your <a href=\"{href}\" target=\"_blank\">profile</a>.",
        "recommendationsForYou": "We recommend content based on your profile settings, the courses you have already taken or materials you have bookmarked."
      },
      "schoolClasses": {
        "videoId": "1170691946",
        "videoTitle": "Learn fobizz Shared Spaces in 90 seconds"
      },
      "toolTips": {
        "recommendationsForYou": "Here you can specify the topics for which recommendations are displayed"
      },
      "tools": {
        "experimental": "Experimental",
        "headers": {
          "title": "Use helpful digital tools with AI integration",
          "subtitle": "What would you like to work with today?"
        },
        "pin": "Pin “{name}”",
        "pinnedAnnouncement": "\"{name}\" is now in \"Pinned Tools\".",
        "pinnedTeaser": "Your favorite tools will be displayed here once you pin them. This allows you to quickly access them.",
        "unpinnedAnnouncement": "\"{name}\" is no longer in \"Pinned Tools\"."
      },
      "webinar": {
        "accessLinkLater": "The access link will appear here later",
        "certificateLater": "Your certificate will appear here later",
        "enrolled": "Enrolled",
        "participated": "Participated",
        "percentComplete": "{percent}% completed",
        "reserveSpot": "Reserve your spot",
        "toCertificate": "Show certificate",
        "toLiveWebinar": "Show webinar"
      }
    }
  }
}
